import { analyticsIds } from './tracker'

const ENDPOINT = '/api/v1/search/interactions/'

function sourcePageUrl() {
  if (typeof window === 'undefined') {
    return ''
  }
  return `${window.location.pathname || '/'}${window.location.search || ''}`
}

function send(body) {
  if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
    const blob = new Blob([body], { type: 'application/json' })
    if (navigator.sendBeacon(ENDPOINT, blob)) {
      return true
    }
  }
  if (typeof fetch === 'undefined') {
    return false
  }
  return fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    keepalive: true,
  }).catch(() => {})
}

export function trackSearchInteraction(payload) {
  try {
    const { visitorId, sessionId } = analyticsIds()
    const body = JSON.stringify({
      visitor_id: visitorId,
      session_id: sessionId,
      source_page_url: sourcePageUrl(),
      ...payload,
    })
    return send(body)
  } catch {
    return false
  }
}
